angular.module('shared').directive('multipleSelect', function() {
  return {
    restrict: 'E',
    template: require('templates/shared/multiple_select.html.slim'),
    replace: true,
    scope: {
      ngModel: '=',
      collection: '=',
      displaySelectAll: '=',
      ngDisabled: '=',
      limitString: '=',
      singleOption: '=',
      fullWidth: '=',
      fullOptionsWidth: '=',
      variant: '@',
      ngChange: '&',
      size: '@',
      labelKey: '@',
      idKey: '@',
      placeholder: '@',
      selectAllLabel: '@'
    },
    controller: ["$scope", "$filter", "$timeout", function($scope, $filter, $timeout) {
      var clearRemovedItems;
      $scope.displaySelectedItems = function() {
        var selectedItems;
        if ($scope.isNoneItemsSelected()) {
          return $scope.placeholder || 'Select';
        } else {
          if (!$scope.collection.length) {
            return;
          }
          selectedItems = _.compact($scope.ngModel.map(function(elem) {
            var item;
            item = _.find($scope.collection, function(item) {
              if ($scope.idKey) {
                return item.id === elem[$scope.idKey] && !elem._destroy;
              } else {
                return item.id === elem;
              }
            });
            if (!item) {
              return null;
            }
            return item[$scope.labelKey || 'name'];
          }));
          if ($scope.fullWidth) {
            return selectedItems.join(', ');
          } else {
            return $filter('limitString')(selectedItems.join(', '), $scope.limitString || 20);
          }
        }
      };
      clearRemovedItems = function(collection, value) {
        var updated;
        if ((collection != null ? collection.length : void 0) && (value != null ? value.length : void 0)) {
          updated = value.filter(function(item) {
            return _.find(collection, function(option) {
              if ($scope.idKey) {
                return option.id === item[$scope.idKey];
              } else {
                return option.id === item;
              }
            });
          });
          if (updated.length !== value.length) {
            $scope.ngModel = updated;
            return $timeout(function() {
              return $scope.ngChange();
            });
          }
        }
      };
      $scope.$watchCollection('ngModel', function(ngModel) {
        return clearRemovedItems($scope.collection, ngModel);
      });
      $scope.$watchCollection('collection', function(collection) {
        return clearRemovedItems(collection, $scope.ngModel);
      });
      $scope.showAllItems = function() {
        $scope.ngModel = [];
        return $timeout(function() {
          return $scope.ngChange();
        });
      };
      $scope.isItemSelected = function(plan) {
        if ($scope.idKey) {
          return _.find($scope.ngModel, function(item) {
            return item[$scope.idKey] === plan.id && !item._destroy;
          });
        } else {
          return $scope.ngModel.indexOf(plan.id) > -1;
        }
      };
      $scope.isNoneItemsSelected = function() {
        var ref;
        if (!((ref = $scope.ngModel) != null ? ref.length : void 0)) {
          return true;
        }
        if ($scope.idKey) {
          return !_.filter($scope.ngModel, function(item) {
            return !item._destroy;
          }).length;
        }
      };
      return $scope.selectItem = function(plan) {
        var item, obj;
        item = $scope.idKey ? (obj = {}, obj[$scope.idKey] = plan.id, obj) : plan.id;
        if ($scope.isNoneItemsSelected()) {
          $scope.ngModel = [item];
        } else {
          if ($scope.isItemSelected(plan)) {
            $scope.ngModel = $scope.idKey ? $scope.ngModel.map(function(elem) {
              if (plan.id === elem[$scope.idKey]) {
                elem._destroy = 1;
              }
              return elem;
            }) : _.without($scope.ngModel, plan.id);
          } else {
            if ($scope.singleOption) {
              $scope.ngModel = [item];
            } else {
              if ($scope.idKey && _.find($scope.ngModel, function(elem) {
                return plan.id === elem[$scope.idKey];
              })) {
                $scope.ngModel = $scope.ngModel.map(function(elem) {
                  if (plan.id === elem[$scope.idKey]) {
                    elem._destroy = void 0;
                  }
                  return elem;
                });
              } else {
                $scope.ngModel.push(item);
              }
              $scope.ngModel = _.filter($scope.ngModel, function(elem) {
                return !!_.find($scope.collection, function(item) {
                  if ($scope.idKey) {
                    return item.id === elem[$scope.idKey];
                  } else {
                    return item.id === elem;
                  }
                });
              });
            }
          }
        }
        return $timeout(function() {
          return $scope.ngChange();
        });
      };
    }]
  };
});
